export default __webpack_public_path__ + "static/media/photo--sm--christina-1.11983303.jpg";